/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "../src/assets/js/main.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "../src/assets/js/main.js":
/*!********************************!*\
  !*** ../src/assets/js/main.js ***!
  \********************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _modules_handle_shopify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./modules/handle-shopify */ "../src/assets/js/modules/handle-shopify.js");
/* harmony import */ var _modules_handle_shopify__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_modules_handle_shopify__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _modules_handle_steps_logic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modules/handle-steps-logic */ "../src/assets/js/modules/handle-steps-logic.js");
/* harmony import */ var _modules_handle_steps_logic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_modules_handle_steps_logic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _modules_handle_change_gift_card_message__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./modules/handle-change-gift-card-message */ "../src/assets/js/modules/handle-change-gift-card-message.js");
/* harmony import */ var _modules_handle_change_gift_card_message__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_modules_handle_change_gift_card_message__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _modules_handle_summary_toggle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./modules/handle-summary-toggle */ "../src/assets/js/modules/handle-summary-toggle.js");
/* harmony import */ var _modules_handle_summary_toggle__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_modules_handle_summary_toggle__WEBPACK_IMPORTED_MODULE_3__);





/***/ }),

/***/ "../src/assets/js/modules/handle-change-gift-card-message.js":
/*!*******************************************************************!*\
  !*** ../src/assets/js/modules/handle-change-gift-card-message.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var $giftMessageBtn = $('.js-gift-message');
var $giftMessageField = $('.js-message-field');
$giftMessageBtn.on('change', function () {
  var $this = $(this);
  var message = $this.data('message');
  $giftMessageField.val(message);
});
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! jquery */ "jquery")))

/***/ }),

/***/ "../src/assets/js/modules/handle-shopify.js":
/*!**************************************************!*\
  !*** ../src/assets/js/modules/handle-shopify.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery, $) {var selected_roast;
var selected_grind;
var selected_range;
var selected_amount;
var selected_plan = 'monthly';
var product_slug;
var selling_plan_group;
var selling_plan_id;
var greeting_card;
var greeting_message;
var specific_requirements;
window.has_prepay = false;
var card_delivery;
var card_name;
var card_email;
var card_from;
var date = new Date();
var year = date.toLocaleString('en-US', {
  timeZone: 'Australia/Melbourne',
  year: "numeric"
});
var month = date.toLocaleString('en-US', {
  timeZone: 'Australia/Melbourne',
  month: "2-digit"
});
var day = date.toLocaleString('en-US', {
  timeZone: 'Australia/Melbourne',
  day: "2-digit"
});
var card_date = year + "-" + month + "-" + day;
var product;
var variants;
var variant_title;
var variant_key;
var variant_id;
var delivery_id;
var frequency = '1 Month';
var hash = window.location.hash;
var debug = false;

if (hash == "#_") {
  debug = true;
  console.log('DEBUG MODE ON');
}

;

function initializeProducts() {
  if (typeof window.RANGE_CONFIG === 'undefined') {
    console.error('RANGE_CONFIG not found. Make sure it is defined in the HTML.');
    return;
  }

  var fetchPromises = [];
  Object.keys(window.RANGE_CONFIG).forEach(function (rangeKey) {
    var rangeConfig = window.RANGE_CONFIG[rangeKey];
    var handle = rangeConfig.handle;
    var productPromise = jQuery.getJSON(window.Shopify.routes.root + 'products/' + handle + '.js').then(function (productData) {
      window.PRODUCT_DATA[rangeKey] = productData;

      if (!window.PRICE_MAP[rangeKey]) {
        window.PRICE_MAP[rangeKey] = {};
      }

      var amounts = new Set();
      var roasts = new Set();
      var grinds = new Set();
      productData.variants.forEach(function (variant) {
        if (variant.option1) amounts.add(variant.option1);
        if (variant.option2) roasts.add(variant.option2);
        if (variant.option3) grinds.add(variant.option3);
        window.PRICE_MAP[rangeKey][variant.option1] = variant.price;
      });
      rangeConfig.amounts = Array.from(amounts);
      rangeConfig.roasts = Array.from(roasts);
      rangeConfig.grinds = Array.from(grinds);

      if (debug) {
        console.log("Loaded product data for ".concat(rangeKey, ":"), productData);
        console.log("Extracted options - Amounts: ".concat(rangeConfig.amounts, ", Roasts: ").concat(rangeConfig.roasts, ", Grinds: ").concat(rangeConfig.grinds));
        console.log("Price map for ".concat(rangeKey, ":"), window.PRICE_MAP[rangeKey]);
      }
    }).fail(function () {
      console.warn("Failed to fetch product: ".concat(handle));
    });
    fetchPromises.push(productPromise);

    if (rangeConfig.hasPrepay && rangeConfig.prepayHandle) {
      var prepayPromise = jQuery.getJSON(window.Shopify.routes.root + 'products/' + rangeConfig.prepayHandle + '.js').then(function (productData) {
        window.PRODUCT_DATA[rangeKey + '-prepay'] = productData;

        if (debug) {
          console.log("Loaded prepay product data for ".concat(rangeKey, ":"), productData);
        }
      }).fail(function () {
        console.warn("Failed to fetch prepay product: ".concat(rangeConfig.prepayHandle));
      });
      fetchPromises.push(prepayPromise);
    }
  });
  Promise.all(fetchPromises).then(function () {
    if (debug) {
      console.log('All products loaded successfully');
      console.log('RANGE_CONFIG (with extracted options):', window.RANGE_CONFIG);
      console.log('PRODUCT_DATA:', window.PRODUCT_DATA);
      console.log('PRICE_MAP:', window.PRICE_MAP);
    }

    $(document).trigger('productsLoaded');
  });
}

$(document).ready(function () {
  initializeProducts();
});
$('.js-option, .js-select select').on('change selectric-change', function () {
  if ($(this).is("select")) {
    $elem = $(this).find(':selected');
  } else {
    $elem = $(this);
  }

  if ($elem.data("roast") !== undefined) {
    selected_roast = $elem.data('roast');
  }

  if ($elem.data("grind") !== undefined) {
    selected_grind = $elem.data('grind');
  }

  if ($elem.data("range") !== undefined) {
    selected_range = $elem.data('range');
  }

  if ($elem.data("amount") !== undefined) {
    selected_amount = $elem.data('amount');
  }

  if ($elem.data("plan") !== undefined) {
    selected_plan = $elem.data('plan');
  }

  if ($elem.data("product-slug") !== undefined) {
    product_slug = $elem.data('product-slug');
  }

  if ($elem.data("selling-plan-group") !== undefined) {
    selling_plan_group = $elem.data('selling-plan-group');
  }

  if ($elem.data("selling-plan-id") !== undefined) {
    selling_plan_id = $elem.data('selling-plan-id');
  }

  if ($elem.data("card-delivery") !== undefined) {
    card_delivery = $elem.data('card-delivery');
  }

  if ($elem.data("delivery-variant-id") !== undefined) {
    delivery_id = $elem.data('delivery-variant-id');
  }

  if ($elem.data("greeting-card") !== undefined) {
    greeting_card = $elem.data('greeting-card');
  }

  if ($elem.data("message") !== undefined) {
    greeting_message = $elem.data('message');
  }

  if ($elem.data("hasprepay") !== undefined) {
    window.has_prepay = $elem.data('hasprepay');
  }

  if (debug) {
    console.log('Selections:');
    console.log({
      selected_roast: selected_roast,
      selected_grind: selected_grind,
      selected_range: selected_range,
      selected_amount: selected_amount,
      selected_plan: selected_plan,
      product_slug: product_slug,
      selling_plan_group: selling_plan_group,
      selling_plan_id: selling_plan_id,
      delivery_id: delivery_id,
      greeting_card: greeting_card,
      greeting_message: greeting_message,
      specific_requirements: specific_requirements,
      card_delivery: card_delivery,
      card_name: card_name,
      card_email: card_email,
      card_from: card_from,
      card_date: card_date,
      has_prepay: window.has_prepay
    });
  }

  if ($elem.data("range") !== undefined) {
    var rangeKey = selected_range;
    var rangeConfig = window.RANGE_CONFIG[rangeKey];

    if (rangeConfig && window.PRODUCT_DATA[rangeKey]) {
      product = window.PRODUCT_DATA[rangeKey];
      variants = product.variants;

      if (product.selling_plan_groups && product.selling_plan_groups.length > 0) {
        selling_plan_group = product.selling_plan_groups[0].id;
        selling_plan_id = product.selling_plan_groups[0].selling_plans[0].id;
      }

      product_slug = rangeConfig.handle;

      if (debug) {
        console.log('Range Product Data:');
        console.log(product);
      }
    }
  }
});
var $giftMessageBtn = $('.js-gift-message');
var $giftMessageField = $('.js-message-field');
$('.js-specific-requirements').on('change paste', function () {
  specific_requirements = $(this).val();

  if (debug) {
    console.log('Specific Requirements: ' + specific_requirements);
  }
});
$('.js-message-field').on('change paste', function () {
  greeting_message = $(this).val();

  if (debug) {
    console.log('Greeting Message: ' + greeting_message);
  }
});
$('.js-card-name').on('change paste', function () {
  card_name = $(this).val();

  if (debug) {
    console.log('Card Name: ' + card_name);
  }
});
$('.js-card-email').on('change paste', function () {
  card_email = $(this).val();

  if (debug) {
    console.log('Card Email: ' + card_email);
  }
});
$('.js-card-from').on('change paste', function () {
  card_from = $(this).val();

  if (debug) {
    console.log('Card From: ' + card_from);
  }
});
$('.js-card-date').on('change paste', function () {
  card_date = $(this).val();

  if (debug) {
    console.log('Card Date: ' + card_date);
  }
});
$('.js-select-form button[type="submit"]').on('click', function (event) {
  event.preventDefault();
  var currentProduct;
  var currentProductKey = selected_range;

  if (selected_plan === 'prepay') {
    currentProductKey = selected_range + '-prepay';
    var rangeConfig = window.RANGE_CONFIG[selected_range];
    product_slug = rangeConfig.prepayHandle;
  } else {
    var _rangeConfig = window.RANGE_CONFIG[selected_range];
    product_slug = _rangeConfig.handle;
  }

  currentProduct = window.PRODUCT_DATA[currentProductKey];

  if (!currentProduct) {
    alert('Product data not loaded. Please wait a moment and try again.');

    if (debug) {
      console.error('Product not found:', currentProductKey);
    }

    return;
  }

  variants = currentProduct.variants;

  if (currentProduct.selling_plan_groups && currentProduct.selling_plan_groups.length > 0) {
    selling_plan_group = currentProduct.selling_plan_groups[0].id;
    selling_plan_id = currentProduct.selling_plan_groups[0].selling_plans[0].id;
  }

  if (selected_amount && selected_roast && selected_grind) {
    variant_title = selected_amount + ' / ' + selected_roast + ' / ' + selected_grind;
  } else {
    alert('Please complete all selections');
    return;
  }

  if (debug) {
    console.log('Variant Title: ' + variant_title);
    console.log('Using Product:', currentProduct);
  }

  $.each(variants, function (key, value) {
    if (debug) {
      console.log(key + ' ' + value.title);
    }

    if (value.title == variant_title) {
      if (debug) {
        console.log('Variant Key: ' + key);
      }

      variant_key = key;
      return false;
    }
  });

  if (variant_key !== undefined) {
    variant_id = variants[variant_key].id;

    if (debug) {
      console.log('Variant ID: ' + variant_id);
    }
  } else {
    alert('Cannot Find Variant');

    if (debug) {
      console.error('Variant not found for title:', variant_title);
      console.log('Available variants:', variants);
    }

    return;
  }

  if (delivery_id !== undefined) {
    addProductsToCart(variant_id, delivery_id);
  } else {
    addSubToCart(variant_id, 1, selling_plan_id);
  }
});

function addSubToCart(variant_id, qty, selling_plan_id) {
  if (selling_plan_id == 1575256200) {
    frequency = '2 Months';
  }

  ;
  var properties = {
    'Specific Requirements': specific_requirements,
    'Greeting Card': greeting_card,
    'Greeting Message': greeting_message,
    'Card Delivery': card_delivery,
    'Card Name': card_name,
    'Card Email': card_email,
    'Card From': card_from,
    '_Frequency': frequency
  };
  data = {
    "id": variant_id,
    "quantity": qty,
    "selling_plan": selling_plan_id,
    properties: properties
  };
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    beforeSend: function beforeSend() {
      $('.form__btn').addClass('loading');
      $('.form__btn').prop('disabled', true);
    },
    success: function success() {
      if (debug) {
        console.log('Added to Cart');
        console.log(data);
      }

      window.location.href = '/checkout';
    },
    error: function error(xhr) {
      alert("Error. Please try again");

      if (debug) {
        console.log(xhr.statusText + xhr.responseText);
      }

      $('.form__btn').removeClass('loading');
      $('.form__btn').prop('disabled', false);
    },
    complete: function complete() {}
  });
}

function addProductsToCart(variant_id, delivery_id) {
  if (card_delivery == 'Home Delivery') {
    card_date = null;
  }

  ;
  var mainProductProperties = {
    'Specific Requirements': specific_requirements,
    'Greeting Card': greeting_card,
    'Greeting Message': greeting_message,
    'Card Delivery': card_delivery,
    'Card Name': card_name,
    'Card Email': card_email,
    'Card From': card_from,
    'Send Date': card_date
  };
  data = {
    items: [{
      id: variant_id,
      quantity: 1,
      properties: mainProductProperties
    }, {
      id: delivery_id,
      quantity: 1
    }]
  };
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    beforeSend: function beforeSend() {
      $('.form__btn').addClass('loading');
      $('.form__btn').prop('disabled', true);
    },
    success: function success() {
      if (debug) {
        console.log('Added to Cart');
        console.log(data);
      }

      window.location.href = '/checkout';
    },
    error: function error(xhr) {
      alert("Error. Please try again");

      if (debug) {
        console.log(xhr.statusText + xhr.responseText);
      }

      $('.form__btn').removeClass('loading');
      $('.form__btn').prop('disabled', false);
    },
    complete: function complete() {}
  });
}

var handleUrlParam = function handleUrlParam() {
  var urlParams = new URLSearchParams(window.location.search);
  var weight = urlParams.get('weight');
  var roast = urlParams.get('roast');
  var range = urlParams.get('range');

  if (weight || roast || range) {
    console.log('URL parameters detected');
    $('html, body').animate({
      scrollTop: $('.js-select-section:first').offset().top - $(window).height() / 2
    }, 500);
    setTimeout(function () {
      if (roast) {
        $(".js-option[data-roast=\"".concat(roast, "\"]")).click();
      }

      setTimeout(function () {
        if (range) {
          $(".js-option[data-range=\"".concat(range, "\"]")).click();
        }

        setTimeout(function () {
          if (weight) {
            $(".js-option[data-amount=\"".concat(weight, "\"]")).click();
          }
        }, 1000);
      }, 1000);
    }, 1000);
  }
};

$(document).ready(function () {
  handleUrlParam();
});
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! jquery */ "jquery"), __webpack_require__(/*! jquery */ "jquery")))

/***/ }),

/***/ "../src/assets/js/modules/handle-steps-logic.js":
/*!******************************************************!*\
  !*** ../src/assets/js/modules/handle-steps-logic.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var listObj = {};
var $selectSection = $(".js-select-section");
var $checkOption = $(".js-option");
var $price = $(".js-price");
var $select = $(".js-select select");
var $dateInput = $(".js-card-date");
var priceMultiply = 1;
var dateSet = 0;
var currentSelections = {
  roast: null,
  grind: null,
  range: null,
  amount: null,
  plan: null
};
var hash = window.location.hash;
var debug = false;

if (hash == "#_") {
  debug = true;
  console.log('DEBUG MODE ON');
}

;

if (typeof window.has_prepay === "undefined") {
  window.has_prepay = false;
}

$('select').selectric({
  disableOnMobile: false,
  nativeOnMobile: false
});
$select.on("selectric-change", function (event, element, selectric) {
  var $element = $(element);
  var $selectedOption = $element.closest(".js-select").find(".selectric-items li.selected");
  var optionIndex = $selectedOption.index();
  var $currentOption = $selectedOption.closest(".js-select").find("select option").eq(optionIndex);
  var $this = $(this);
  var $currentSelectSection = $this.closest(".js-select-section");
  var $currentSelectForm = $this.closest(".js-select-form");
  var dataSection = $currentOption.data("open");

  if ($element.attr('id') === 'select-coffee-amount' && $currentOption && $currentOption.val()) {
    currentSelections.amount = $currentOption.val();
  }

  handleSelectionChange($this, dataSection, $currentSelectSection, $currentSelectForm, true, $element, $currentOption);
});
$checkOption.on("change", function () {
  var $this = $(this);
  var $currentSelectSection = $this.closest(".js-select-section");
  var $currentSelectForm = $this.closest(".js-select-form");
  var dataSection = $this.data("open");
  handleSelectionChange($this, dataSection, $currentSelectSection, $currentSelectForm, false);
});

function updateAvailableOptions() {
  if (typeof window.RANGE_CONFIG === 'undefined') {
    return;
  }

  if (currentSelections.roast) {
    $('.js-range-option').each(function () {
      var $li = $(this);
      var validRoasts = $li.data('valid-roasts');

      if (validRoasts) {
        var validRoastsArray = validRoasts.split(',');

        if (validRoastsArray.includes(currentSelections.roast)) {
          $li.removeClass('is-hidden').show();
        } else {
          $li.addClass('is-hidden').hide();
        }
      }
    });
  }

  if (currentSelections.range) {
    var rangeConfig = window.RANGE_CONFIG[currentSelections.range];

    if (rangeConfig) {
      $('.js-amount-option').each(function () {
        var $li = $(this);
        var $input = $li.find('input');
        var amount = $input.data('amount');

        if (rangeConfig.amounts.includes(amount)) {
          $li.removeClass('is-hidden').show();
        } else {
          $li.addClass('is-hidden').hide();
        }
      });
      updatePricesForRange(currentSelections.range);
      renderExtraSizesSelect(rangeConfig);
      updatePromoBadges();
    }
  }

  updatePrepayAvailability();
}

function updatePromoBadges() {
  var range = currentSelections.range;
  var badges = window.PROMO_BADGES;
  $('.js-promo-badge').hide().text('');
  if (!range || !badges || !badges[range]) return;
  var rangeBadges = badges[range];
  $('.js-promo-badge').each(function() {
    var amount = $(this).data('badge-amount');
    var text = rangeBadges[amount];
    if (text && text.trim() !== '') {
      $(this).text(text).show();
    }
  });
}

function updatePromoFooterText() {
  var $el = $('.js-promo-footer-text');
  var isPrepay = $('.js-option#coffee-plan-2').is(':checked');
  if (isPrepay) {
    $el.hide().text('');
    return;
  }
  var range = currentSelections.range;
  var amount = currentSelections.amount;
  var badges = window.PROMO_BADGES;
  if (range && amount && badges && badges[range] && badges[range][amount]) {
    var text = badges[range][amount];
    if (text && text.trim() !== '') {
      $el.text(text).show();
      return;
    }
  }
  $el.hide().text('');
}

function updatePricesForRange(rangeKey) {
  if (!window.PRICE_MAP || !window.PRICE_MAP[rangeKey]) {
    return;
  }

  var priceMap = window.PRICE_MAP[rangeKey];
  $('.js-amount-option').each(function () {
    var $li = $(this);
    var $input = $li.find('input');
    var amount = $input.data('amount');

    if (priceMap[amount]) {
      $input.data('price', priceMap[amount]);

      if (debug) {
        console.log("Set price for ".concat(amount, " in ").concat(rangeKey, ": ").concat(priceMap[amount]));
      }
    }
  });
}

function renderExtraSizesSelect(rangeConfig) {
  var $amountSection = $('.coffee-amount');
  var $selectLi = $amountSection.find('li.js-amount-select');
  var $selectWrap = $selectLi.find('.js-select');
  var $sel = $selectWrap.find('select');
  var radioAmounts = ['250g', '500g', '1kg'];
  var allowedExtraAmounts = ['750g', '1.5kg', '2kg'];
  var extraAmounts = (rangeConfig.amounts || []).filter(function (a) {
    return !radioAmounts.includes(a);
  }).filter(function (a) {
    return allowedExtraAmounts.includes(a);
  }).sort(function (a, b) {
    return allowedExtraAmounts.indexOf(a) - allowedExtraAmounts.indexOf(b);
  });

  if (extraAmounts.length === 0) {
    $sel.prop('selectedIndex', 0).selectric('refresh');
    $selectLi.hide().removeClass('is-hidden');
    $selectWrap.removeClass('is-selected');
    return;
  }

  var priceMap = window.PRICE_MAP && window.PRICE_MAP[currentSelections.range] || {};
  var currentValue = $sel.val();
  var $placeholder = $sel.find('option.select__placeholder');
  $sel.empty().append($placeholder);
  extraAmounts.forEach(function (amount) {
    var priceCents = parseInt(priceMap[amount], 10) || 0;
    var opt = document.createElement('option');
    opt.value = amount;
    opt.textContent = amount;
    opt.setAttribute('data-amount', amount);
    opt.setAttribute('data-open', 'plan-select');
    opt.setAttribute('data-selection', amount + ' per Month');
    opt.setAttribute('data-price', String(priceCents));
    opt.setAttribute('data-option-1', amount);
    $sel.append(opt);
  });

  if (currentValue && extraAmounts.includes(currentValue)) {
    $sel.val(currentValue);
    $selectWrap.addClass('is-selected');
  }

  $selectLi.show();
  $sel.selectric('refresh');
}

function updatePrepayAvailability() {
  var $prepayLi = $('.js-prepay-option');
  var $prepayOption = $('#coffee-plan-2');
  var $monthlyOption = $('#coffee-plan-1');
  var $planSection = $('.plan-select');

  if (currentSelections.range) {
    var rangeConfig = window.RANGE_CONFIG[currentSelections.range];

    if (rangeConfig && rangeConfig.hasPrepay) {
      if (currentSelections.amount && currentSelections.roast && currentSelections.grind) {
        var prepayProductKey = currentSelections.range + '-prepay';
        var prepayProduct = window.PRODUCT_DATA[prepayProductKey];

        if (prepayProduct && prepayProduct.variants) {
          var expectedVariantTitle = "".concat(currentSelections.amount, " / ").concat(currentSelections.roast, " / ").concat(currentSelections.grind);
          var variantExists = prepayProduct.variants.some(function (variant) {
            return variant.title === expectedVariantTitle && variant.available;
          });

          if (variantExists) {
            window.has_prepay = true;
            $prepayLi.show();

            if ($planSection.is(':visible') && !$planSection.find('input:checked').length) {
              $monthlyOption.prop('checked', true);
              $planSection.addClass('is-selected');
            }
          } else {
            window.has_prepay = false;
            $prepayLi.hide();

            if ($prepayOption.is(':checked')) {
              $monthlyOption.prop('checked', true).trigger('change');
            }
          }
        } else {
          window.has_prepay = false;
          $prepayLi.hide();
        }
      } else {
        window.has_prepay = true;
        $prepayLi.show();
      }
    } else {
      window.has_prepay = false;
      $prepayLi.hide();

      if ($prepayOption.is(':checked')) {
        $monthlyOption.prop('checked', true).trigger('change');
      }
    }
  }
}

function handleSelectionReset(changedSelection) {
  if (changedSelection === 'roast') {
    if (currentSelections.range) {
      var rangeConfig = window.RANGE_CONFIG[currentSelections.range];

      if (rangeConfig && !rangeConfig.roasts.includes(currentSelections.roast)) {
        if (debug) {
          console.log('Range invalid for new roast, resetting...');
        }

        $('input[name="coffee-range"]:checked').prop('checked', false);
        currentSelections.range = null;
        $('.coffee-amount').removeClass('is-selected is-visible').hide();
        $('input[name="coffee-amount"]:checked').prop('checked', false);
        currentSelections.amount = null;
        $('.plan-select').removeClass('is-selected is-visible').hide();
        $('input[name="coffee-plan"]:checked').prop('checked', false);
        currentSelections.plan = null;
        $('.coffee-more').removeClass('is-visible').hide();
      }
    }
  } else if (changedSelection === 'range') {
    if (currentSelections.amount) {
      var _rangeConfig = window.RANGE_CONFIG[currentSelections.range];

      if (_rangeConfig && !_rangeConfig.amounts.includes(currentSelections.amount)) {
        if (debug) {
          console.log('Amount invalid for new range, resetting...');
        }

        $('input[name="coffee-amount"]:checked').prop('checked', false);
        currentSelections.amount = null;
        $('.plan-select').removeClass('is-selected is-visible').hide();
        $('input[name="coffee-plan"]:checked').prop('checked', false);
        currentSelections.plan = null;
        $('.coffee-more').removeClass('is-visible').hide();
      }
    }
  }
}

function handleSelectionChange($triggerElement, dataSection, $currentSelectSection, $currentSelectForm, isSelect, $element, $currentOption) {
  var formFoot = $currentSelectForm.find(".form__foot");
  var formFootHeight = formFoot.outerHeight() / 2;

  if ($triggerElement.data('roast') !== undefined) {
    currentSelections.roast = $triggerElement.data('roast');
    handleSelectionReset('roast');
  }

  if ($triggerElement.data('grind') !== undefined) {
    currentSelections.grind = $triggerElement.data('grind');
  }

  if ($triggerElement.data('range') !== undefined) {
    currentSelections.range = $triggerElement.data('range');
    handleSelectionReset('range');
  }

  if ($triggerElement.data('amount') !== undefined) {
    currentSelections.amount = $triggerElement.data('amount');
  }

  if ($triggerElement.data('plan') !== undefined) {
    currentSelections.plan = $triggerElement.data('plan');
  }

  updateAvailableOptions();

  if (isSelect) {
    $triggerElement.closest(".js-select").addClass("is-selected");
  }

  $currentSelectSection.addClass("is-selected");
  var $planSection = $(".plan-select");
  var $monthlyOption = $('.js-option#coffee-plan-1');
  var $prepayOption = $('.js-option#coffee-plan-2');
  var $prepayLi = $prepayOption.closest("li");
  var $prepaySection = $(".plan-select");

  if (window.has_prepay === true) {
    $prepayLi.show();

    if ($(".coffee-more").is(":visible")) {
      $planSection.show();

      if ($planSection.find(".js-option:checked").length === 0) {
        $monthlyOption.prop("checked", true);
        $prepaySection.addClass("is-selected");
      }
    }
  } else {
    if ($prepayOption.is(":checked")) {
      $prepayOption.prop("checked", false);
      $prepaySection.removeClass("is-selected");
    }

    $prepayLi.hide();
    closeSection($planSection);
  }

  var sectionToOpen = dataSection;

  if (dataSection === 'plan-select') {
    if (window.has_prepay !== true) {
      sectionToOpen = 'coffee-more';
    } else {
      $monthlyOption.prop("checked", true);
      $prepaySection.addClass("is-selected");
      $(".coffee-more").addClass("is-visible").css("display", "block");
    }
  }

  if (sectionToOpen) {
    var $sectionToOpen = $(".".concat(sectionToOpen));
    openSection($sectionToOpen, formFoot, formFootHeight);
  }

  if (isSelect) {
    var $currentSelectSectionRadioOptions = $currentSelectSection.find(".js-option");
    $currentSelectSectionRadioOptions.prop("checked", false);

    if ($currentOption && $element) {
      var selectedValue = $currentOption.html();
      var listData = $currentSelectSection.data("list");
      var selectionText = "".concat(selectedValue, " ").concat($element.data("select") || "");
      listObj[listData] = selectionText;
      createList(listObj);
    }

    if (typeof checkIfFormIsCompleted === "function") {
      checkIfFormIsCompleted($currentSelectForm);
    }
  } else {
    if ($triggerElement.data("price-multiply") !== undefined) {
      priceMultiply = $triggerElement.data("price-multiply");
    }

    handleResetSelect($currentSelectSection);
  }

  function handleResetSelect(section) {
    var $currentSelect = section.find(".js-select");
    var hasSelect = $currentSelect.length > 0;

    if (hasSelect) {
      $select.prop("selectedIndex", 0).selectric("refresh");
      $select.closest(".js-select").removeClass("is-selected");
    }
  }

  validateForm($currentSelectSection);
  handleSummary();
  handleDate();
}

var $requiredFields = $(".js-required-field");

if ($requiredFields.length > 0) {
  $requiredFields.on("keyup", function () {
    var $this = $(this);
    var validateType = $this.attr("type");
    var val = $this.val();
    var emailPattern = /^[0-9a-zA-ZÐ"Â¤Ð"ÒÐ"Â¶]+([0-9a-zA-ZÐ"Â¤Ð"ÒÐ"Â¶]*[-._+])*[0-9a-zA-zÐ"Â¤Ð"ÒÐ"Â¶]+@[0-9a-zA-ZÐ"Â¤Ð"ÒÐ"Â¶]+([-.][0-9a-zA-ZÐ"Â¤Ð"ÒÐ"Â¶]+)*([0-9a-zA-ZÐ"Â¤Ð"ÒÐ"Â¶]*[.])[a-zA-ZÐ"Â¤Ð"ÒÐ"Â¶]{2,6}$/;
    var emptyVal = val === "";
    var $currentSelectSection = $this.closest(".js-select-section");

    if (validateType === "email") {
      $currentSelectSection.toggleClass("is-selected", emailPattern.test(val));
      $this.closest(".form__controls").toggleClass("error", !emailPattern.test(val));
    } else {
      $currentSelectSection.toggleClass("is-selected", !emptyVal);
      $this.closest(".form__controls").toggleClass("error", emptyVal);
    }

    validateForm($currentSelectSection);
  });
}

var validateForm = function validateForm($currentSelectSection) {
  if (debug) console.log("Validating form...");
  var $currentSelectForm = $currentSelectSection.closest(".js-select-form");
  var currentIndex = $currentSelectSection.index();
  var requiredFields = $(".js-select-section.is-visible.is-required");
  var requiredSelectedFields = $(".js-select-section.is-visible.is-required.is-selected");

  if (currentIndex === 0) {
    $currentSelectForm.addClass("show-foot");
  }

  var isLastVisible = !$("[data-last]").hasClass("is-visible");
  var allRequiredFieldSelected = requiredFields.length === requiredSelectedFields.length;
  $currentSelectForm.toggleClass("is-full", !isLastVisible);

  if (!isLastVisible && allRequiredFieldSelected) {
    $currentSelectForm.addClass("is-completed");
    $currentSelectForm.find(".form__btn").prop("disabled", false);
    if (debug) console.log("\uD83D\uDFE2 Form is completed.");
  } else {
    $currentSelectForm.removeClass("is-completed");
    $currentSelectForm.find(".form__btn").prop("disabled", true);
    if (debug) console.log("\uD83D\uDD34 Form is NOT completed.");
    requiredFields.each(function () {
      var $section = $(this);
      var sectionName = $section.data("list");

      if (!$section.hasClass("is-selected") && debug) {
        console.log("Section not completed: ".concat(sectionName));
      }
    });
  }
};

var openSection = function openSection(sectionToOpen, formFoot, formFootHeight) {
  if (sectionToOpen.length === 0) {
    return;
  }

  sectionToOpen.addClass("is-visible");
  sectionToOpen.stop(true, true).slideDown(300, function () {
    sectionToOpen.addClass("is-visible").css("display", "block");
  });
  setTimeout(function () {
    if (sectionToOpen.length && sectionToOpen.is(":visible")) {
      var scrollPosition;
      var winHeight = $(window).outerHeight() / 2;

      if (sectionToOpen.length === 1) {
        var sectionHeight = sectionToOpen.outerHeight() / 2;
        scrollPosition = sectionToOpen.offset().top + sectionHeight - winHeight + formFootHeight;
      } else {
        var _sectionHeight = sectionToOpen[0].outerHeight();

        scrollPosition = sectionToOpen.offset().top + _sectionHeight - winHeight + formFootHeight;
      }

      $("html, body").stop(true, true).animate({
        scrollTop: scrollPosition
      }, 300);
    }
  }, 300);
};

var closeSection = function closeSection(sectionToClose) {
  if (sectionToClose.length === 0) {
    return;
  }

  sectionToClose.removeClass("is-visible");
  sectionToClose.stop().slideUp(300, function () {
    sectionToClose.css("display", "none");
  });
};

var handleSummary = function handleSummary() {
  listObj = {};
  var price = 0;
  var selectionText = "";
  var dataPrice;
  $(".js-select-section.is-selected").each(function (index, section) {
    var $section = $(this);
    var listData = $section.data("list");

    if (!listData && !$section.find("[data-price]").length) {
      return true;
    }

    var selectOptions = $section.find(".js-select .selectric-items li:not(.select__placeholder).selected");

    if (selectOptions.length > 0) {
      var optionIndex = selectOptions.index();
      var $option = $section.find(".js-select select option").eq(optionIndex);
      selectionText = $option.data("selection") || $option.text();

      if ($option.data("price") !== undefined) {
        dataPrice = parseInt($option.data("price"), 10) || 0;
        price += dataPrice;
      }
    } else {
        var $checkedOption = $section.find(".js-option:checked");
        var isPrepayOption = $checkedOption.attr('id') === 'coffee-plan-2';

        if ($checkedOption.length > 0) {
          selectionText = $checkedOption.data("selection") || $checkedOption.val() || $checkedOption.siblings('label').text() || "Selected";

          if ($section.data('list') === 'amount' && currentSelections.range && currentSelections.amount) {
            if (window.PRICE_MAP && window.PRICE_MAP[currentSelections.range]) {
              dataPrice = parseInt(window.PRICE_MAP[currentSelections.range][currentSelections.amount], 10) || 0;
            }
          } else if (isPrepayOption && $checkedOption.data("prepay-price") !== undefined) {
            dataPrice = parseInt($checkedOption.data("prepay-price"), 10) || 0;
          } else if ($checkedOption.data("price") !== undefined) {
            dataPrice = parseInt($checkedOption.data("price"), 10) || 0;
          } else {
            dataPrice = 0;
          }

          price += dataPrice;
        } else {
          selectionText = "";
          dataPrice = 0;
        }
      }

    if (selectionText && listData) {
      listObj[listData] = selectionText;
    }
  });
  createList(listObj);
  var $prepayOption = $('.js-option#coffee-plan-2');
  var isPrepaySelected = $prepayOption.is(":checked");
  var prepayComparePrice = 0;
  var finalPrice = price / 100;

  if (isPrepaySelected) {
    finalPrice = price * priceMultiply / 100;
    prepayComparePrice = price * (priceMultiply + 1) / 100;
  }

  var $priceElement = $(".js-price");
  $priceElement.closest(".price").toggleClass("is-set", price > 0);
  $priceElement.text(finalPrice);
  var $prepayPriceCompareElement = $(".js-price-prepay-compare span");
  $prepayPriceCompareElement.text(prepayComparePrice);

  if (isPrepaySelected) {
    $(".show-monthly").hide();
    $(".show-prepaid").show();
  } else {
    $(".show-monthly").show();
    $(".show-prepaid").hide();
  }

  updatePromoFooterText();
};

var createList = function createList(object) {
  var $selectionList = $(".js-selection-list");
  $selectionList.empty();

  if (object.roast && object.grind) {
    var combinedRoastGrind = "".concat(object.roast, " - ").concat(object.grind);
    $selectionList.append("<li><span>\u2192</span> ".concat(combinedRoastGrind, "</li>"));

    for (var _i = 0, _Object$entries = Object.entries(object); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];

      if (key !== 'roast' && key !== 'grind' && key !== 'plan') {
        $selectionList.append("<li><span>\u2192</span> ".concat(value, "</li>"));
      }
    }
  } else {
    for (var _i2 = 0, _Object$entries2 = Object.entries(object); _i2 < _Object$entries2.length; _i2++) {
      var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
          _key = _Object$entries2$_i[0],
          _value = _Object$entries2$_i[1];

      if (_key !== 'plan') {
        $selectionList.append("<li><span>\u2192</span> ".concat(_value, "</li>"));
      }
    }
  }
};

var handleDate = function handleDate() {
  Date.prototype.addDays = function (days) {
    this.setDate(this.getDate() + parseInt(days));
    return this;
  };

  if ($dateInput && $(".js-date-section").hasClass("is-visible") && dateSet != 1) {
    dateSet = 1;
    var date = new Date();
    var year = date.toLocaleString("en-US", {
      timeZone: "Australia/Melbourne",
      year: "numeric"
    });
    var month = date.toLocaleString("en-US", {
      timeZone: "Australia/Melbourne",
      month: "2-digit"
    });
    var day = date.toLocaleString("en-US", {
      timeZone: "Australia/Melbourne",
      day: "2-digit"
    });
    var formattedDate = year + "-" + month + "-" + day;
    var plus30date = new Date().addDays(30);
    var plus30year = plus30date.toLocaleString("en-US", {
      timeZone: "Australia/Melbourne",
      year: "numeric"
    });
    var plus30month = plus30date.toLocaleString("en-US", {
      timeZone: "Australia/Melbourne",
      month: "2-digit"
    });
    var plus30day = plus30date.toLocaleString("en-US", {
      timeZone: "Australia/Melbourne",
      day: "2-digit"
    });
    var plus30formattedDate = plus30year + "-" + plus30month + "-" + plus30day;
    $dateInput.val(formattedDate);
    $dateInput[0].min = formattedDate;
    $dateInput[0].max = plus30formattedDate;
  }
};

function handleUrlSelections() {
  var urlParams = new URLSearchParams(window.location.search);
  var selectParam = urlParams.get('select');

  if (!selectParam) {
    return;
  }

  console.log("URL Selection Parameter detected:", selectParam);
  var selectionIds = selectParam.split(',');

  if (selectionIds.length === 0) {
    return;
  }

  window.inUrlSelectionMode = true;
  var originalOpenSection = window.openSection || openSection;
  var originalAnimate = $.fn.animate;

  window.openSection = function (sectionToOpen) {
    if (!sectionToOpen || sectionToOpen.length === 0) {
      return;
    }

    sectionToOpen.addClass('is-visible').css('display', 'block');
  };

  $.fn.animate = function (properties) {
    if (window.inUrlSelectionMode && properties && (properties.scrollTop !== undefined || properties.scrollLeft !== undefined)) {
      return this;
    }

    return originalAnimate.apply(this, arguments);
  };

  var processIndex = 0;

  function processNextSelection() {
    if (processIndex >= selectionIds.length) {
      setTimeout(function () {
        window.openSection = originalOpenSection;
        $.fn.animate = originalAnimate;
        setTimeout(function () {
          window.inUrlSelectionMode = false;
          console.log("All URL selections fully completed - normal scrolling restored");
        }, 1000);
        console.log("All URL selections processed - restored original functions");
        handleSummary();
        validateForm($('.js-select-section.is-selected').last());
      }, 300);
      return;
    }

    var selectionId = selectionIds[processIndex];
    var $element = $('#' + selectionId);
    processIndex++;

    if ($element.length === 0) {
      console.warn("Element with ID '".concat(selectionId, "' not found"));
      processNextSelection();
      return;
    }

    console.log("Processing selection: ".concat(selectionId));

    if ($element.is('input[type="radio"]')) {
      $element.prop('checked', true);
      $element.trigger('change');
      setTimeout(processNextSelection, 100);
    } else if ($element.is('select')) {
      $element.val(selectionId).selectric('refresh');
      $element.trigger('selectric-change');
      setTimeout(processNextSelection, 100);
    } else {
      console.warn("Unsupported element type for ID '".concat(selectionId, "'"));
      processNextSelection();
    }
  }

  processNextSelection();
}

var originalValidateForm = validateForm;

function enhancedValidateForm($currentSelectSection) {
  validateForm($currentSelectSection);

  if (window.inUrlSelectionMode) {}
}

$(document).ready(function () {
  setTimeout(handleUrlSelections, 500);
});
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! jquery */ "jquery")))

/***/ }),

/***/ "../src/assets/js/modules/handle-summary-toggle.js":
/*!*********************************************************!*\
  !*** ../src/assets/js/modules/handle-summary-toggle.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var $summary = $('.js-summary');
var $win = $(window);
$summary.on('click', '.summary__head', function (event) {
  if ($win.outerWidth() > 1023) {
    return;
  } else {
    $(this).closest('.js-summary').toggleClass('is-active').find('.summary__body').stop().slideToggle();
  }

  event.preventDefault();
});
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! jquery */ "jquery")))

/***/ }),

/***/ "jquery":
/*!*************************!*\
  !*** external "jQuery" ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ })

/******/ });